import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c30cd3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-[321px] tw-text-[#878787] tw-text-[14px] tw-text-center" }
const _hoisted_2 = { class: "tw-flex tw-items-center" }
const _hoisted_3 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_4 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_5 = { class: "name-header-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/double-icon.svg",
  alt: "double-icon",
  class: "name-header-text tw-ml-1"
}, null, -1))
const _hoisted_7 = { class: "tw-flex cell-org-name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_10 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_11 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "information tw-flex tw-mr-12 tw-items-center tw-h-[20px]" }
const _hoisted_14 = { class: "name tw-font-semibold tw-pt-[2px]" }
const _hoisted_15 = {
  key: 0,
  class: "tw-ml-[10px]",
  src: "/img/home_icon.svg"
}
const _hoisted_16 = {
  key: 1,
  class: "current-text basic-text tw-items-center tw-mt-[2px] tw-h-[20px]"
}
const _hoisted_17 = { class: "tw-flex" }
const _hoisted_18 = { class: "tw-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!
  const _component_CustomDropDownItem = _resolveComponent("CustomDropDownItem")!
  const _component_ButtonShowMore = _resolveComponent("ButtonShowMore")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createBlock(_component_b_table, {
    items: _ctx.tableData,
    fields: _ctx.tableFields,
    striped: true,
    responsive: "sm",
    "thead-class": "tb-bg-gray",
    class: _normalizeClass(['setting-table manage-org-table']),
    "tbody-tr-class": _ctx.rowClass,
    "show-empty": ""
  }, {
    empty: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.getUiText("app-manage-orgs-empty-organisation-text-1")), 1)
      ])
    ]),
    "head(name)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "icon-select",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSelectAll(!_ctx.isSelectAll)))
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
            [_vShow, _ctx.isSelectAll]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
            [_vShow, !_ctx.isSelectAll]
          ])
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(data.label.toUpperCase()), 1),
        _hoisted_6
      ])
    ]),
    "cell(name)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "icon-select",
          onClick: ($event: any) => (_ctx.toggleDetails(data.index))
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_vShow, _ctx.selected[data.index]?.isSelectedRow]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
            [_vShow, !_ctx.selected[data.index]?.isSelectedRow]
          ])
        ], 8, _hoisted_8),
        _createElementVNode("div", _hoisted_11, [
          (data.value?.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: data.value.icon,
                alt: "person_random"
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(data.value), 1),
            (data.item.isHome)
              ? (_openBlock(), _createElementBlock("img", _hoisted_15))
              : _createCommentVNode("", true),
            (
                data.item.id === _ctx.currentOrg.id && data.item.isDefaultVerified
              )
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.getUiText("app-manage-orgs-current-org-1")), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    "cell(userRoles)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (role, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "cell-role tw-text-sm tw-font-medium tw-flex tw-items-center"
          }, [
            _createElementVNode("span", null, _toDisplayString(role.roleName), 1)
          ]))
        }), 128))
      ])
    ]),
    "cell(status)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_18, [
        (data.item.isDefaultVerified)
          ? (_openBlock(), _createBlock(_component_StatusBadge, {
              key: 0,
              class: "tw-w-fit",
              value: _ctx.statusCode.verify
            }, null, 8, ["value"]))
          : (data.item.isArchived)
            ? (_openBlock(), _createBlock(_component_StatusBadge, {
                key: 1,
                class: "tw-w-fit",
                value: _ctx.statusCode.archived
              }, null, 8, ["value"]))
            : (data.item.isVerified)
              ? (_openBlock(), _createBlock(_component_StatusBadge, {
                  key: 2,
                  class: "tw-w-fit",
                  value: _ctx.statusCode.pendingVerify
                }, null, 8, ["value"]))
              : (_openBlock(), _createBlock(_component_StatusBadge, {
                  key: 3,
                  class: "tw-w-fit",
                  value: _ctx.statusCode.notVerify
                }, null, 8, ["value"]))
      ])
    ]),
    "cell(actionManage)": _withCtx((data) => [
      (!(data.item.id === _ctx.currentOrg.id && data.item.isDefaultVerified))
        ? (_openBlock(), _createBlock(_component_ButtonShowMore, {
            key: 0,
            "id-popover": 'popover-btn-show-more-manage-org-table-' + data.index
          }, _createSlots({ _: 2 }, [
            (data.item.isDefaultVerified)
              ? {
                  name: "default",
                  fn: _withCtx(() => [
                    _createVNode(_component_CustomDropDownItem, {
                      style: 'normal',
                      "id-text": 'app-manage-orgs-switch-org-text-1',
                      onClick: () => _ctx.$emit('switch_org', data.item)
                    }, null, 8, ["onClick"]),
                    (!data.item.isHome)
                      ? (_openBlock(), _createBlock(_component_CustomDropDownItem, {
                          key: 0,
                          style: 'danger',
                          "id-text": 'app-manage-orgs-leave-org-text-1',
                          onClick: () => _ctx.$emit('leave_org', data.item)
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : (data.item.isArchived)
                ? {
                    name: "default",
                    fn: _withCtx(() => [
                      _createVNode(_component_CustomDropDownItem, {
                        style: 'normal',
                        "id-text": 'app-manage-orgs-unarchive-request-org-text-1',
                        onClick: () => _ctx.$emit('archive_org', data.item, false)
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_CustomDropDownItem, {
                        style: 'danger',
                        "id-text": 'app-manage-orgs-delete-request-org-text-1',
                        onClick: () => _ctx.$emit('delete_org', data.item.id)
                      }, null, 8, ["onClick"])
                    ]),
                    key: "1"
                  }
                : (data.item.isVerified)
                  ? {
                      name: "default",
                      fn: _withCtx(() => [
                        _createVNode(_component_CustomDropDownItem, {
                          style: 'normal',
                          "id-text": 'app-manage-orgs-create-request-org-text-1',
                          onClick: () => _ctx.$emit('create_org', data.item)
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_CustomDropDownItem, {
                          style: 'danger',
                          "id-text": 'app-manage-orgs-archive-request-org-text-1',
                          onClick: () => _ctx.$emit('archive_org', data.item, true)
                        }, null, 8, ["onClick"])
                      ]),
                      key: "2"
                    }
                  : {
                      name: "default",
                      fn: _withCtx(() => [
                        _createVNode(_component_CustomDropDownItem, {
                          style: 'normal',
                          "id-text": 'app-manage-orgs-edit-request-org-text-1',
                          onClick: () => _ctx.$emit('edit_request', data.item)
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_CustomDropDownItem, {
                          style: 'danger',
                          "id-text": 'app-manage-orgs-archive-request-org-text-1',
                          onClick: () => _ctx.$emit('archive_org', data.item, true)
                        }, null, 8, ["onClick"])
                      ]),
                      key: "3"
                    }
          ]), 1032, ["id-popover"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["items", "fields", "tbody-tr-class"]))
}